import { FilterParams } from "../users.type";
import { RoleType } from "@/store/auth/auth.type";
import { useCityMap } from "./use-city-map";
import { useGetUsers } from "./use-users";
import { useMemo } from "react";

export const useUsersWithCities = (role: RoleType, filter: FilterParams, enabled = false) => {
  const { users, loading: usersLoading, error: usersError, refetch } = useGetUsers(role, filter, enabled);
  const { cityMap, loading: citiesLoading, error: citiesError } = useCityMap();

  const mappedUsers = useMemo(() => {
    if (!users) return { results: [], totalPages: 0 };

    return {
      ...users,
      results: users.results.map((user) => ({
        ...user,
        citiesDisplay: user.cities
          ?.map((id) => cityMap.get(id) ?? null)
          .filter((city): city is string => city !== null),
      })),
    };
  }, [users, cityMap]);

  return {
    loading: usersLoading || citiesLoading,
    error: usersError || citiesError,
    mappedUsers,
    refetch,
  };
};
